module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ThePage', {
    attrs: {
      "class-name": 'TableView',
      "title": 'TABLE__TABLE'
    }
  }, [_c('template', {
    slot: "left-action"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "icon": 'icon-left'
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('TheTableSearch'), _vm._v(" "), _c('TheTablePaging'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "TableView__content"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0),
      expression: "items.length>0"
    }],
    staticClass: "TableView__table"
  }, [_c('thead', {
    staticClass: "TableView__head"
  }, [_c('tr', {
    staticClass: "TableView__head-row"
  }, [_c('th', {
    staticClass: "TableView__head-cell",
    on: {
      "click": function($event) {
        _vm.setOrder('name')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__NAME')))]), _vm._v(" "), (_vm.sortByColumn('name')) ? _c('span', [(_vm.isAsc) ? _c('i', {
    staticClass: "icon-up-dir"
  }) : _c('i', {
    staticClass: "icon-down-dir"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "TableView__head-cell",
    on: {
      "click": function($event) {
        _vm.setOrder('phone')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__PHONE')))]), _vm._v(" "), (_vm.sortByColumn('phone')) ? _c('span', [(_vm.isAsc) ? _c('i', {
    staticClass: "icon-up-dir"
  }) : _c('i', {
    staticClass: "icon-down-dir"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "TableView__head-cell",
    on: {
      "click": function($event) {
        _vm.setOrder('company')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__COMPANY')))]), _vm._v(" "), (_vm.sortByColumn('company')) ? _c('span', [(_vm.isAsc) ? _c('i', {
    staticClass: "icon-up-dir"
  }) : _c('i', {
    staticClass: "icon-down-dir"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "TableView__head-cell",
    on: {
      "click": function($event) {
        _vm.setOrder('city')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__CITY')))]), _vm._v(" "), (_vm.sortByColumn('city')) ? _c('span', [(_vm.isAsc) ? _c('i', {
    staticClass: "icon-up-dir"
  }) : _c('i', {
    staticClass: "icon-down-dir"
  })]) : _vm._e()])])]), _vm._v(" "), _c('tbody', {
    staticClass: "TableView__body"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('tr', {
      key: item.id,
      staticClass: "TableView__row"
    }, [_c('td', {
      staticClass: "TableView__cell"
    }, [_c('div', {
      staticClass: "TableView__cell-title",
      on: {
        "click": function($event) {
          _vm.setOrder('name')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__NAME')))]), _vm._v(" "), (_vm.sortByColumn('name')) ? _c('span', [(_vm.isAsc) ? _c('i', {
      staticClass: "icon-up-dir"
    }) : _c('i', {
      staticClass: "icon-down-dir"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "TableView__cell-content"
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "TableView__cell"
    }, [_c('div', {
      staticClass: "TableView__cell-title",
      on: {
        "click": function($event) {
          _vm.setOrder('phone')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__PHONE')))]), _vm._v(" "), (_vm.sortByColumn('phone')) ? _c('span', [(_vm.isAsc) ? _c('i', {
      staticClass: "icon-up-dir"
    }) : _c('i', {
      staticClass: "icon-down-dir"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "TableView__cell-content"
    }, [_vm._v("\n                            " + _vm._s(item.phone) + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "TableView__cell"
    }, [_c('div', {
      staticClass: "TableView__cell-title",
      on: {
        "click": function($event) {
          _vm.setOrder('company')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__COMPANY')))]), _vm._v(" "), (_vm.sortByColumn('company')) ? _c('span', [(_vm.isAsc) ? _c('i', {
      staticClass: "icon-up-dir"
    }) : _c('i', {
      staticClass: "icon-down-dir"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "TableView__cell-content"
    }, [_vm._v("\n                            " + _vm._s(item.company) + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "TableView__cell"
    }, [_c('div', {
      staticClass: "TableView__cell-title",
      on: {
        "click": function($event) {
          _vm.setOrder('city')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__CITY')))]), _vm._v(" "), (_vm.sortByColumn('city')) ? _c('span', [(_vm.isAsc) ? _c('i', {
      staticClass: "icon-up-dir"
    }) : _c('i', {
      staticClass: "icon-down-dir"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "TableView__cell-content"
    }, [_vm._v("\n                            " + _vm._s(item.city) + "\n                        ")])])])
  }))])]), _vm._v(" "), _c('BaseLoader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoaded),
      expression: "!isLoaded"
    }]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27125b2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TableView.vue
// module id = 587
// module chunks = 1